<script>
import {mapActions} from "pinia";
import {baseLoaderStore} from "@/store/baseLoaderStore";

export default {
  name: "ManagerCriticalEvents",
  props: {
    userId: {
      type: Number
    }
  },
  computed: {
    frameUrl() {
      return `/user/${this.userId}/mydesktop?tab=events&_f=true&showAsPage=false`
    }
  },
  methods: {
    ...mapActions(baseLoaderStore, [
      'hideBaseLoader'
    ]),
  },
  mounted() {
    document.getElementById('managerViewFrame').onload = () => {
      this.hideBaseLoader();
    };
  }
}
</script>

<template>
  <div>
    <iframe :src="frameUrl" frameborder="0" id="managerViewFrame" class="critical-events-view-frame"></iframe>
  </div>
</template>

<style lang="scss">

.critical-events-view-frame {
  width: 100%;
  height: 1240px;
}

</style>